const SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
export function transformActivitiesItems(query, activities = {}) {
  if (!activities || !activities.nodes) {
    return [];
  }
  return activities.nodes.map(item => {
    const {
      object,
      timestamp
    } = item;
    const {
      cloudId,
      events,
      extension,
      iconUrl,
      id,
      localResourceId,
      name,
      product,
      url,
      type
    } = object;
    // V2 returns eventType captilised, V3 returns lowercase
    const eventType = events[0].eventType.toLowerCase();
    const issueKey = extension && extension.issueKey;
    let containers = [];
    if (issueKey) {
      containers.push({
        name: issueKey
      });
    }
    if (Array.isArray(object.containers)) {
      containers = containers.concat(object.containers);
    }
    containers = containers.filter(container => !!container.name);
    return {
      query,
      containers,
      contributors: (object.contributors || []).reduce((contributors, contributor) => {
        if (contributor.profile) {
          const {
            accountId,
            picture
          } = contributor.profile;
          contributors.push({
            accountId,
            name: contributor.profile.name,
            picture
          });
        }
        return contributors;
      }, []),
      eventType,
      object: {
        rootContainerIdentifier: {
          id: cloudId,
          type: 'SITE',
          ari: `${SITE_ARI_PREFIX}${cloudId}`
        },
        deduplicateId: id,
        icon: {
          type: 'URL',
          value: iconUrl
        },
        id,
        localResourceId,
        name,
        product,
        subProduct: null,
        type,
        url
      },
      timestamp
    };
  });
}